export const MapContainerStyle = {
  width: "100%",
  height: "400px",
};

export const center = {
  lat: 36.13817904641932,
  lng: -5.846385661096199,
};
